import React from "react";
import { observer, inject } from "mobx-react";
import { Row, Col, Table, Button, Form, ButtonGroup, DropdownButton, Dropdown, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RouteComponentProps, Link } from "react-router-dom";
import { STORE_VIN_QUERIES } from "../../../constants";
import { VinQueriesStore, VinQueryDetails } from "../../../stores";
import { formatDate, formatMoney } from "../../../common/Formatting";
import { LinkContainer } from "react-router-bootstrap";
import { runInAction } from "mobx";
import { wrapCheckbox, wrapInput } from "../../../common/FormChangeWrapper";
import { Left } from "react-bootstrap/lib/Media";

interface IProps {
    history: any,
    [STORE_VIN_QUERIES]: VinQueriesStore
}

interface IState {
    id: number;
    vinQueryDetails?: VinQueryDetails;
    formUniqueKey: number;
    newMessage: string;
}


type Props = IProps & RouteComponentProps<{ id: string, backUrl: string }>;

@inject(STORE_VIN_QUERIES)
@observer
export class VinQueryDetailsPage extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        const id = parseInt(this.props.match.params.id);
        this.state = {
            id: id,
            newMessage: "",
            formUniqueKey: new Date().getTime()
        };
    }

    private vinQueriesStore = (this.props as any)[STORE_VIN_QUERIES] as VinQueriesStore;


    componentDidMount() {
        this.vinQueriesStore.loadVinQueryDetails(this.state.id, (vinQuery: VinQueryDetails) => {
            this.setState({
                vinQueryDetails: vinQuery
            })
        });
    }
    componentDidUpdate(prevProps: Props, prevState: IState, snapshot: any) {
        if (prevProps.match.params.id !== this.props.match.params.id) {
            const id = parseInt(this.props.match.params.id);
            this.setState({
                id: id
            }, this.loadVinQueryDetails);

        }
    }

    private loadVinQueryDetails = () => {
        this.vinQueriesStore.loadVinQueryDetails(this.state.id, (vinQuery: VinQueryDetails) => {
            this.setState({
                vinQueryDetails: vinQuery
            })
        });
    }

    onMessageChange = (fieldName: string, value: string) => {
        this.setState({
            newMessage: value
        })
    }

    sendMessage = () => {
        if (this.state.newMessage == null) {
            this.vinQueriesStore._rootStore.commonStore.notifyError("Пустой текст сообщения");
        }
        else
            this.vinQueriesStore.sendMessage(this.state.newMessage, this.state.id, this.state.formUniqueKey, this.loadVinQueryDetails);
    }

    render() {

        const backUrl = this.props.match.params.backUrl != null && this.props.match.params.backUrl.length > 0 ?
            decodeURIComponent(this.props.match.params.backUrl)
            : "/sales/vinqueries/";

        return <div>
            <Row>
                <Col md={12}>
                    <br />
                    <h3>
                        Детали VIN-запроса
                        <LinkContainer to={backUrl}>
                            <Link to={backUrl}>
                                <span style={{ fontSize: "1rem", marginLeft: "20px" }}>
                                    <FontAwesomeIcon icon="arrow-left" />
                                    Вернуться к списку запросов
                                </span>
                            </Link>
                        </LinkContainer>
                        <Button type="button" size="sm" style={{ marginLeft: "20px" }} onClick={() => {
                            this.props.history.push("/sales/newcustomerorder/-1/" + this.state.id)
                        }}>
                            <FontAwesomeIcon icon="plus" />
                            {' '}
                            Создать коммерческое предложение
                        </Button>
                    </h3>
                    <br />
                </Col>
            </Row>
            {this.state.vinQueryDetails == null ? [] : <div>
                <Row>
                    <Col sm="4">

                        <Table bordered size="sm">
                            <tbody>
                                <tr>
                                    <th style={{ width: "200px" }}>Клиент</th>
                                    <td className="text-center" style={{ width: "300px" }}>
                                        {`${this.state.vinQueryDetails.customerName || "фио не указано"}`} <br /> {`тел. ${this.state.vinQueryDetails.customerPhone}`}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={{ width: "200px" }}>Телефон для связи</th>
                                    <td className="text-center" style={{ width: "300px" }}>
                                        {this.state.vinQueryDetails.comment}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={{ width: "200px" }}>Дата запроса</th>
                                    <td className="text-center">{formatDate(this.state.vinQueryDetails.dateAdded)}</td>
                                </tr>
                                <tr>
                                    <th style={{ width: "200px" }}>Автомобиль</th>
                                    <td className="text-center">{this.state.vinQueryDetails.carName}</td>
                                </tr>
                                {this.state.vinQueryDetails.year != null ?
                                    <tr>
                                        <th style={{ width: "200px" }}>Год</th>
                                        <td className="text-center">{this.state.vinQueryDetails.year}</td>
                                    </tr>
                                    : null}
                                <tr>
                                    <th style={{ width: "200px" }}>Комментарий к автомобилю</th>
                                    <td className="text-center">{this.state.vinQueryDetails.carComment}</td>
                                </tr>
                                <tr>
                                    <th style={{ width: "200px" }}>VIN/FRAME код</th>
                                    <td className="text-center">{this.state.vinQueryDetails.vin}</td>
                                </tr>
                                {this.state.vinQueryDetails.engineDisplacement != null ?
                                    <tr>
                                        <th style={{ width: "200px" }}>Объем двигателя</th>
                                        <td className="text-center">{this.state.vinQueryDetails.engineDisplacement}</td>
                                    </tr>
                                    : null}
                                {this.state.vinQueryDetails.engineCapacity != null ?
                                    <tr>
                                        <th style={{ width: "200px" }}>Мощность двигателя</th>
                                        <td className="text-center">{this.state.vinQueryDetails.engineCapacity}</td>
                                    </tr>
                                    : null}
                                {this.state.vinQueryDetails.engineType != null ?
                                    <tr>
                                        <th style={{ width: "200px" }}>Тип двигателя</th>
                                        <td className="text-center">{this.state.vinQueryDetails.engineType}</td>
                                    </tr>
                                    : null}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>

                        <Table bordered size="sm">
                            <thead>
                                <tr>
                                    <th className="text-center">№</th>
                                    <th>Деталь</th>
                                    <th className="text-center">Количество</th>
                                    <th className="text-center">Тип</th>
                                    <th>Комментарий</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.vinQueryDetails.items.map((item, index) => <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.description}</td>
                                    <td className="text-center">{item.count}</td>
                                    <td className="text-center">{item.type}</td>
                                    <td>{item.comment}</td>
                                </tr>)}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </div>
            }
            <Card>
                <Card.Body>
                    <Row>
                        <Col sm="12">
                            <h3>Сообщения</h3>
                        </Col>
                    </Row>
                    {(this.state.vinQueryDetails?.messages || []).map((message, index) => [<br key={"rowBr_" + index} />, <Row key={"rowMessage_" + index}>
                        <Col sm={message.isManager ? { span: 9, offset: 3 } : { span: 9 }}>
                            <Card className={message.isManager ? "border-success" : ""}>
                                <Card.Header className={message.isManager ? "text-right" : ""}>{message.userName}{' '}{formatDate(message.date)}</Card.Header>
                                <Card.Body>
                                    {message.message}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>])}
                    <hr />
                    <Row>
                        <Col sm={12}>

                            <Card>
                                <Card.Body>

                                    <div style={{ margin: "0 100px" }}>
                                        <div style={{ float: "left", width: "100%", paddingRight: "170px", marginRight: "-160px" }}>
                                            <textarea rows={4} style={{ width: "100%", height: "100px" }} value={this.state.newMessage} onChange={wrapInput(this.onMessageChange)}></textarea>
                                        </div>
                                        <div style={{ float: "left", width: "150px" }}>
                                            <Button type="button" size="lg" variant="primary" style={{ width: "100%", height: "100px" }} onClick={this.sendMessage}>Отправить</Button>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </div >
    }


}